<template>
    <el-dialog center :append-to-body="true" :title="newTitle" width="80%" :before-close="handleClose"
               :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div class="report_list">
        <el-form size="mini" ref="form">
          <div style="display: flex;">
        <el-form-item label="提报日期" prop="start_date" :label-width="formLabelWidth">
          <el-date-picker
              v-model="start_date"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="-"
              placeholder="开始日期"
              :disabled="isedit"
              :picker-options="pickerOptions_plt"
              :clearable = false
              @change="change"/>
        </el-form-item>
            <el-form-item :label-width="formLabelWidth">
          <el-button size="mini" type="warning" @click="toEdit">补 交</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="el-icon-warning" style="text-align: right;
      color: red;
    font-size: 12px;
    position: absolute;
    right: 0;
    margin-right: 52px;">1工作日 = 6工时，请合理填写</div>
      <el-table
          :data="reportData"
          border
          stripe
          style="width: 100%"
          :cell-style="getRowClassReport"
          :header-cell-style="getCellClassReport"
           height="40vh">
        <el-table-column prop="task_id" fixed label="任务ID" width="80" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="task_name" label="任务名称" min-width="120" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="module" width="100" label="系统" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="status_desc" label="状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="bug_total_count" width="80" label="BUG" :show-overflow-tooltip="true" v-if="type !== 1">
          <template slot-scope="scope">
            <span>{{scope.row.bug_handle_count}} / {{scope.row.bug_total_count}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="planFinishDate" width="120" label="计划完成日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="estimate_work_hour" width="120" label="预估工时(小时)" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="cost_work_hour"  width="120" label="已耗时(小时)" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="todayCost" width="120" label="任务耗时(小时)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              <el-input type="number" size="small" v-model="scope.row.today_cost" @change="changeNumber(scope.row,'today_cost')"></el-input>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="todayBugCost"  width="120" label="BUG耗时(小时)" :show-overflow-tooltip="true" v-if="type != 1">
          <template slot-scope="scope">
            <div>
              <el-input type="number" :disabled="scope.row.bug_handle_count === 0" size="small" v-model="scope.row.today_bug_cost"  @change="changeNumber(scope.row,'today_bug_cost')"></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
            <div slot="footer" class="dialog-footer">
<!--              <el-button   style="margin-left:0;"  type="warning" @click="onSubmit">编 辑</el-button>-->
              <el-button   style="margin-left:0;" :loading="loading.submit" type="warning" @click="onSubmit">提 交</el-button>
<!--              <el-button type="success" @click="handleClose">关 闭</el-button>-->
            </div>
    </el-dialog>

</template>
<script>
import { mapState, mapMutations } from 'vuex';
import {
  postDevOpsSpaceAddTeamApi, postDevOpsSpaceDleteUserApi,
  postDevOpsSpaceSUbmitReportApi, postDevOpsSpaceUpdateTeamApi
} from "@/server/tops/devOps";
export default {
  components:{},
  props:{
    newTitle:{
      default: '',
    },
    reportData: {
      type:Object,
      default: function () {
        return {}
      },
    },
    type:{
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    changeReportDate: {
      type: Function,
      default: function () {
        return () => { }
      }
    },

  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          allStatusList: (state) => state.devOps.ALLSTATUSLIST,
        }
    )
  },
  data() {
    return {
      start_date: this.getNowDate(),
      formLabelWidth: '70px',
      isedit: true,
      loading:{
        submit: false,
      },
      pickerOptions_plt: {
        disabledDate: (time) => {
          return this.disabledDate('plt', time)
        }
      },
    }
  },
  created() {
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.username = username;
  },
  methods: {
    // 关闭编辑弹窗
    handleMeetClose() {
      this.dialogVisibleMeet = false;
    },
    meetDetaile(row,isedit) {
      this.checkDataInfo = row;
      this.isedit = isedit;
      this.dialogVisibleMeet = true;
    },
    // 表格样式
    getRowClassReport({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    getCellClassReport(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    handleInputChange(row,type){
      let params = {};
      params.taskId = row.task_id;
      params.taskType = Number(row.task_type);
      params.workDate = this.start_date;
      if(type === 'todayCost'){
        row.today_cost = this.changeNumber(row.today_cost);
        params.todayCost = row.today_cost;
        params.todayBugCost = row.today_bug_cost ? Number(row.today_bug_cost) : 0 ;
      }
      if(type === 'todayBugCost'){
        row.today_bug_cost = this.changeNumber(row.today_bug_cost);
        params.todayBugCost = row.today_bug_cost;
        params.todayCost = row.today_cost ? Number(row.today_cost) : 0;
      }
      if(params.todayCost || params.todayBugCost){
        this.submitReport(params);
      }
    },
     async onSubmit() {
      //计算总工时
       if(this.reportData.length > 0){
         let total_time = 0;
         let arr = [];
         let totalNum = 0
         this.reportData.forEach((r)=>{
           total_time = total_time+ Number(r.today_cost);
           let todayCost = r.today_cost ? r.today_cost : 0;
           let todayBugCost = r.today_bug_cost ? r.today_bug_cost : 0;
           arr.push({workDate:this.start_date,todayCost:todayCost,todayBugCost:todayBugCost,task_id:r.task_id,task_type:Number(r.task_type),});
           if(todayCost > 0){
             totalNum ++;
           }
         })
         let start_date = this.start_date;
        // let content = start_date  + "日提交任务数："+totalNum+"工时数："+ total_time;
         const h = this.$createElement
         let content = h('div', [h('p', start_date  + "日：提交任务数："+totalNum), h('p',"工时数："+ total_time)])
       this.$confirm(content, "提示", {
         confirmButtonText: "确定",
         cancelButtonText: "取消",
         type: "warning",
       }).then(async () => {
         try {
           this.$set(this.loading, 'submit', true)
           // id 存在 更新 不存在 创建
           const ret = await postDevOpsSpaceSUbmitReportApi({task_list:arr});
           if (ret.status === 'success') {
             this.$notify({
               message: ret.message || '提交成功',
               type: "success",
             })
             this.$emit('change',  this.start_date);
             this.handleClose();
           } else {
             this.$notify({
               message: ret.message || "失败",
               type: "error",
             })
           }
         } catch (error) {
           this.$notify({
             message: error || "网络错误",
             type: "error",
           })
         } finally {
           this.loading.submit = false;
         }
       });
       }
     },
    changeNumber(row,type) {
      let value = row[type].replace(/^(0+)|[^\d]+/g,'');
      value = value.replace(/(\d{15})\d*!/, '$1') // 最多保留15位整数
      row[type] = Number(value);
    },
    //工时只能正整数
   /* changeNumber(e) {
      let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*!/, '$1') // 最多保留15位整数
      return  Number(value);
    },*/
    submitReport(params){
      postDevOpsSpaceSUbmitReportApi(params).then((res)=>{
        if(res.status === 'success'){
          this.$notify({
            message: res.message || "保存成功",
            type: "success",
          })
          this.$emit('change',  this.start_date);
        }else{
          this.$notify({
            message: res.message || "保存失败",
            type: "error",
          })
        }
      });
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    toEdit(){
      this.isedit = false;
    },
    change(val){
      this.$emit('change', val);
    },
    disabledDate(type, time) {
      const nowTime = Date.now() - 60 * 60 * 24 * 1000;
      switch (type) {
        case 'plt':
            return time.getTime() <= (new Date()).getTime() - 60 * 60 * 24 * 1000 * 7;
      }
    },
  },
}
</script>
<style>
/*.report_list {
  max-height: 275px;
  overflow-y: auto;
  white-space: pre-wrap;
  !* background: #f1fbec; *!
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}*/

/*.report_list::-webkit-scrollbar {
  !*滚动条整体样式*!
  width: 10px;
  !*高宽分别对应横竖滚动条的尺寸*!
  height: 16px;
}*/

/*.report_list::-webkit-scrollbar-thumb {
  !*滚动条里面小方块*!
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
  rgba(255, 255, 255, 0.2) 25%,
  transparent 25%,
  transparent 50%,
  rgba(255, 255, 255, 0.2) 50%,
  rgba(255, 255, 255, 0.2) 75%,
  transparent 75%,
  transparent);
}*/
/*
.report_list::-webkit-scrollbar-track {
  !*滚动条里面轨道*!
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}*/
</style>
